// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--1Sa5J";